<template>
  <div class="container-fluid">
    <b-modal ref="modal-remark" v-model="getShow"  header-bg-variant="secondary" footer-bg-variant="secondary" size="lg" centered no-close-on-esc no-close-on-backdrop hide-header-close >
        <template v-slot:modal-title>
            <h2>หมายเหตุ</h2>
        </template>
        <div class="flex-container">
            <div v-for="(values , key) in data" :key="key">
                <slot :name="`custom-header-${key}`">{{key}}</slot>
                <div class="flex-row">
                    <div v-for="(value , type , i) in values" :key="i" class="custom-size-details">
                        <template v-if="checkTypeofObj(value)">
                          <h4 class="dash"><slot :name="`custom-${type}`">{{type}}</slot>{{' : '}}&nbsp;</h4>
                          <div v-for="(value_in_obj , type_in_obj , n) in value" :key="n">
                            <label><slot :name="`custom-${type_in_obj}`"></slot></label>
                            <label>{{value_in_obj}}</label>
                          </div>
                        </template>
                        <template v-else>
                          <h4 class="dash"><slot :name="`custom-${type}`">{{type}}</slot>{{' : '}}</h4><label>&nbsp;{{value}}</label>
                        </template>
                    </div>
                </div>
            </div>
        </div>
        <template v-slot:modal-footer>
            <div class="w-100">
                <b-button
                variant="primary"
                size="xl"
                class="float-right mx-1"
                @click="submit()" >
                {{'ปิด'}}
                </b-button>
            </div>
        </template>
    </b-modal>
  </div>
</template>
<script>
export default {
  props: {
      getDetails: Object ,
      getShow   : Boolean ,
      submit    : Function 
    },
  data() {
    return {
      showModal: true
    }
  },
  methods: {
    checkTypeofObj( obj ){
      return typeof obj === 'object' && obj !== null
    }
  },
  computed:{
    show(){
      return this.getShow ? true : false
    },
    data(){
        if( Object.keys( this.getDetails ).length === 0 && this.getDetails.constructor === Object ){
            return []
        }
        return this.getDetails.data
    }
  }
};
</script>
<style lang="scss" scoped>

    .flex-row{
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        margin: 1%;
    }
    .flex-container{
        display: flex;
        flex-direction: column;
    }
    .custom-size-details{
        display: flex;
        flex: 0 50%;
        flex-direction: row;
        white-space: nowrap;
        overflow-x: auto;
    }
    .dash:before{
        content: "- ";
        color: #000000;
    }  
</style>